var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C12.4183 0 16 3.83756 16 8.57143C16 12.6675 13.4201 16.4369 8.35792 19.8883C8.13954 20.0372 7.86046 20.0372 7.64208 19.8883C2.57993 16.4369 0 12.6675 0 8.57143C0 3.83756 3.58172 0 8 0ZM8 1.42857C4.3181 1.42857 1.33333 4.62654 1.33333 8.57143C1.33333 11.8934 3.38628 15.0824 7.5741 18.1311L8 18.4355L8.4259 18.1311C12.6137 15.0824 14.6667 11.8934 14.6667 8.57143C14.6667 4.62654 11.6819 1.42857 8 1.42857ZM8 6.42857C9.10457 6.42857 10 7.38796 10 8.57143C10 9.7549 9.10457 10.7143 8 10.7143C6.89543 10.7143 6 9.7549 6 8.57143C6 7.38796 6.89543 6.42857 8 6.42857Z",
    fill: "#E84E1B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.168be37187087b7b127eb707efec1028.svg";
export { ForwardRef as ReactComponent };